<template>
  <div>
    <section class="hero">
      <h1 class="sr-only">Dragonfly Massage &mdash; Massage Therapy in Springfield, MO</h1>
      <img src="@/assets/logo.svg" alt="Dragonfly Massage" />
      <p>Every body is unique and worthy of special treatment.</p>
      <a class="book-button" target="_blank" rel="noopener"
        href="https://calendly.com/cj-dragonflymassage">Book Now</a>
    </section>
    <router-link to="/gift-cards" class="gift-banner">
      <i class="pi pi-gift" aria-hidden="true"></i>
      Give the Gift of Relief: Holiday Gift Cards
    </router-link>
    <div class="hello">
    <div class="dragonfly-divider"><img src="@/assets/mark.svg" alt="" /></div>
    <div class="homeCards">
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-heart card-icon" aria-hidden="true"></i>
        </template>
        <template #title>Welcome</template>
        <template #subtitle>Every body is unique and worthy of special treatment!</template>
        <template #content>
          <p>
            Dragonfly Massage is the practice of CJ Berkstresser, a Licensed Massage Therapist (LMT) in
            Springfield, MO. Whether you are looking to unwind, recover, or simply be cared for, each session is
            tailored to you and your ever-changing body.
          </p>
          <p>
            The dragonfly is our symbol of healing, hope, and endurance. We would love to help you feel your best.
          </p>
        </template>
      </Card>
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-list card-icon" aria-hidden="true"></i>
        </template>
        <template #title>What We Offer</template>

        <template #content>
          <p>Customized massage, built around what your body needs:</p>
          <ul>
            <li>Swedish (Relaxation) Massage</li>
            <li>Deep Tissue &amp; Trigger Point Therapy</li>
            <li>Manual Lymphatic Drainage (MLD)</li>
            <li>Prenatal Massage</li>
            <li>Kinetic Stretching &amp; Table Thai</li>
            <li>Combo &amp; Kinetic / Relaxation Split sessions</li>
            <li><router-link to="/corporate">Corporate &amp; Workplace Massage</router-link></li>
          </ul>
          <p>
            See the <router-link to="/services">Services</router-link> and
            <router-link to="/pricing">Pricing</router-link> pages for details.
          </p>
        </template>

      </Card>
      <Card class="homeCard">
        <template #header>
          <i class="pi pi-calendar card-icon" aria-hidden="true"></i>
        </template>
        <template #title>Book &amp; Contact</template>

        <template #content>
          <p>Book online at either location:</p>
          <p>
            <b>Main Location &mdash; Dragonfly Massage</b><br>
            Suite 32, Sola Salon Studios<br>
            1839-B E Independence St<br>
            Springfield, MO 65804
          </p>
          <p>
            <a class="book-button" target="_blank" rel="noopener"
              href="https://calendly.com/cj-dragonflymassage">Book at Main
              Location</a>
          </p>
          <p>
            <b>Partner Location &mdash; Counter Negative</b><br>
            3800 S Fremont Ave<br>
            Springfield, MO 65804
          </p>
          <p>
            <a class="book-button" target="_blank" rel="noopener"
              href="https://www.counternegative.com/book-now">Book at Counter Negative</a>
          </p>
          <p>Prefer to reach out directly? Contact CJ:</p>
          <ul>
            <li><a href="tel:417-929-2533">417-929-2533</a></li>
            <li><a href="mailto:cj.dragonflymassage@gmail.com">cj.dragonflymassage@gmail.com</a></li>
          </ul>
          <p>
            Follow Dragonfly Massage on
            <a target="_blank" rel="noopener" href="https://www.facebook.com/DragonflyMassageSGF">Facebook</a>,
            and Counter Negative on
            <a target="_blank" rel="noopener"
              href="https://www.facebook.com/counternegativerecoveryandwellness">Facebook</a>.
          </p>
          <i>Wishing you wellness!</i>
        </template>

      </Card>
    </div>
    </div>
  </div>

</template>

<script lang="ts">
export default {
  name: "HomePage",
}
</script>

<script lang="ts" setup>
import Card from 'primevue/card';
import 'primeicons/primeicons.css';
</script>
